import * as React from 'react';
import RefereeQuestion, { RefereeQuestionTypes } from '../../../models/be/RefereeQuestion';
import { RefereeAnswer } from '../../../models/be/RefereeAnswer';
import EditButton from '../../common/buttons/EditButton';
import Option from '../../../models/Option';
import './ReadOnlyQuestion.less';
import { getDateInDayMonthYearFormat, hasValue } from '../../../lib/utils';

// ToDo: Reuse Question component
const ReadOnlyQuestion = (props: Props) => {
	const { refereeAnswer: answer, refereeQuestion } = props;

	const answerLimit = 150;
	const [showSeeMore, setShowSeeMore] = React.useState(
		typeof answer === 'string' && answer.toString().length > answerLimit
	);

	return (
		<section className="readOnlyQuestion">
			<div className="topRow">
				<span className="questionNumber">{props.indexInQuestionArray + 1}.</span>
				<span>
					<span className="questionText">{refereeQuestion.text}</span>
					<EditButton onClick={props.onEditButtonClick} />
				</span>
			</div>
			{showSeeMore ? (
				<>
					<div className="answer">{`${answer.toString().substring(0, answerLimit + 1)}...`}</div>
					<span className="seeMoreText" onClick={() => setShowSeeMore(false)}>
						See more
					</span>
				</>
			) : (
				<div className="answer">{renderAnswer(refereeQuestion, answer)}</div>
			)}
		</section>
	);
};

interface Props {
	refereeQuestion: RefereeQuestion;
	refereeAnswer: RefereeAnswer;
	indexInQuestionArray: number;
	onEditButtonClick: () => void;
}

const renderAnswer = (question: RefereeQuestion, answer: RefereeAnswer) => {
	const { type } = question;

	if (!hasValue(answer)) return '';

	if (
		type === RefereeQuestionTypes.Text ||
		type === RefereeQuestionTypes.Number ||
		type === RefereeQuestionTypes.Slider ||
		answer === null
	) {
		return answer;
	}
	if (type === RefereeQuestionTypes.CheckList) {
		return (answer as string[]).map((x) => <p>{question.options.find((y) => y.value === x)?.text}</p>);
	}
	if (type === RefereeQuestionTypes.Dropdown) {
		return (answer as Option<string>)?.text;
	}
	if (type === RefereeQuestionTypes.RadioList) {
		return answer;
	}
	if (type === RefereeQuestionTypes.Date) {
		return getDateInDayMonthYearFormat(new Date(answer as string));
	}
	if (type === RefereeQuestionTypes.Boolean) {
		return answer.toString();
	}
	throw new Error(`Unknown type: ${type}.`);
};

export default ReadOnlyQuestion;
